export const pokemongo = `メルタン
メルメタル`;
